import { formatMoney, roundDown } from "./formatMoney";

export const calculatePaymentPlan = ({ price, text, amount }) => {
  const monthlyPayment = roundDown(price);
  const numberMonths = Number(text.replace("months", ""));
  const monthlyPayments = roundDown(monthlyPayment * (numberMonths - 1));
  const firstMonth = formatMoney(Number(amount) - monthlyPayments);
  return { monthlyPayment, numberMonths, monthlyPayments, firstMonth };
};
